import React, { Component } from 'react';
import {Button} from "react-bootstrap";
import BasicLoader from '../../../../../components/Loader/BasicLoader';
import isNumeric from 'validator/lib/isNumeric';
import SpinnerLoader from '../../../../../components/Loader/Spinner';
import _ from 'lodash';
import {Checkbox} from "antd";

const styles = {
  wrapper: {
    width: '100%',
    fontFamily: "'Manrope', sans-serif",
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
  },
  body: {
    flex: 1,
    padding: '12px 24px 24px 24px',
    overflowY: 'auto',
  },
  row: {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
  },
  fieldGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  label: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    color: '#55607e',
    marginBottom: '6px',
  },
  menuSectionTitle: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    color: '#55607e',
    marginBottom: '12px',
    marginTop: '16px',
  },
  menuGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    marginBottom: '16px',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '6px 0',
    borderBottom: '1px solid #f0f0f0',
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
  },
  menuItemLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    color: '#374151',
  },
  counterBox: {
    border: '1px solid #D6D6D6',
    borderRadius: '3px',
    fontSize: '12px',
    display: 'flex',
    lineHeight: '1.7',
  },
  counterBtn: { padding: '0px 7px', color: '#2563eb', cursor: 'pointer' },
  counterVal: { padding: '0px 7px', backgroundColor: '#f8f8f8' },
  addItemBtn: {
    border: '1px solid #D6D6D6',
    borderRadius: '3px',
    color: '#737373',
    fontSize: '12px',
    display: 'flex',
    lineHeight: '1.7',
    cursor: 'pointer',
  },
  footer: {
    paddingTop: '16px',
    borderTop: '1px solid #e8e8e8',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '16px',
  },
  saveBtn: {
    backgroundColor: '#2563eb',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '0 28px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    height: '42px',
    minWidth: '110px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

class EditPackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package: {},
      menu: []
    };
  }

  componentDidMount() {
    let menu = this.props.menu ? this.props.menu : [];
    this.setState({
      package: this.props.package,
      menu: menu
    }, () => {
      this.handlePrapareMenu(menu);
    });
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props, prevProps)) {
      let menu = this.props.menu ? this.props.menu : [];
      this.setState({
        package: this.props.package,
        menu: menu
      }, () => {
        this.handlePrapareMenu(menu);
      });
    }
  }

  handlePrapareMenu = (menu) => {
    const newMenu = menu.map(item => {
      const newItem = { ...item };
      if (newItem.count && newItem.count > 0) {
        newItem.isSelected = true;
        newItem.selectedCount = newItem.count;
      } else {
        newItem.isSelected = false;
        newItem.selectedCount = 0;
      }
      return newItem;
    });
    this.setState({
      menu: newMenu
    });
  };

  handleMethodOfContactChange = () => {};

  checkPackageValidation = (pack) => {
    let isValid = true;
    if (!!!pack.name || pack.name === '') {
      isValid = false;
      this.props.showMessage('Please Provide Package Name.', 'warning');
    } else if (!!!pack.package_price || pack.package_price === '') {
      isValid = false;
      this.props.showMessage('Please Provide Package price', 'warning');
    } else if (!isNumeric(pack.package_price?.toString())) {
      isValid = false;
      this.props.showMessage('Please Enter Numeric Package price', 'warning');
    } else if (!!!pack.menuItems || pack.menuItems.length === 0) {
      isValid = false;
      this.props.showMessage('Please Select Some Menu Items', 'warning');
    }
    return isValid;
  };

  savePackage = () => {
    let newPackage = { ...this.props.package };
    newPackage.name = this.packageName.value;
    newPackage.package_price = this.packagePrice.value;
    newPackage.menuItems = [...this.state.menu].filter(item => item.isSelected === true);
    newPackage.menuItems = newPackage.menuItems.map(item => {
      return {
        count: item.selectedCount,
        menuId: item._id,
        name: item.name,
      };
    });
    if (this.checkPackageValidation(newPackage)) {
      this.props.updatePackage(newPackage);
    }
  };

  handleIncrementMenuItem = (id) => {
    const menu = this.state.menu.map(item => {
      if (item._id === id) {
        const newItem = { ...item };
        if (newItem.selectedCount === 0) {
          newItem.isSelected = true;
        }
        if (newItem.count) {
          if (newItem.selectedCount < newItem.count) {
            newItem.selectedCount = newItem.selectedCount + 1;
          } else {
            this.props.showMessage('Max count reached', 'warning');
          }
        } else {
          newItem.selectedCount = newItem.selectedCount + 1;
        }
        return newItem;
      }
      return item;
    });

    this.setState({
      menu: menu
    });
  };

  handleDecrementMenuItem = (id) => {
    const menu = this.state.menu.map(item => {
      if (item._id === id) {
        const newItem = { ...item };
        if (newItem.selectedCount > 0) {
          newItem.selectedCount = newItem.selectedCount - 1;
        }
        if (newItem.selectedCount === 0) {
          newItem.isSelected = false;
        }
        return newItem;
      }
      return item;
    });

    this.setState({
      menu: menu
    });
  };

  handleSelectMenuItem = (id, value) => {
    const menu = this.state.menu.map(item => {
      if (item._id === id) {
        const newItem = { ...item };
        newItem.isSelected = !value;
        if (newItem.isSelected) {
          newItem.selectedCount = 1;
        } else {
          newItem.selectedCount = 0;
        }
        return newItem;
      }
      return item;
    });

    this.setState({
      menu: menu
    });
  };

  render() {
    let staticContent = this?.props?.staticContent ? this.props.staticContent : {};

    return (
      <div style={styles.wrapper}>
        <div className="custom-drawer-header">
            <span className="custom-drawer-title">
                {staticContent.PACKAGE_PAGE_PACKAGE_EDIT_TITLE || 'Edit Package'}
            </span>
            <button className="custom-drawer-close-btn" onClick={this.props.handleCloseEditPackageOverlay}>✕</button>
        </div>
        <div style={styles.body}>
          <div style={styles.row}>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>{staticContent.PACKAGE_PAGE_PACKAGE_NAME_LABEL ? staticContent.PACKAGE_PAGE_PACKAGE_NAME_LABEL : 'Package Name'}</label>
              <input
                type="text"
                defaultValue={this?.state?.package?.name ? _.startCase(this.state.package.name) : ''}
                className="form-control"
                ref={(ref) => this.packageName = ref}
                style={{ height: '44px', borderRadius: '8px' }}
              />
            </div>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>{staticContent.PACKAGE_PAGE_PACKAGE_PRICE_LABEL ? staticContent.PACKAGE_PAGE_PACKAGE_PRICE_LABEL : 'Price'}</label>
              <input
                type="text"
                defaultValue={this?.state?.package?.package_price ? this.state.package.package_price : ''}
                className="form-control"
                ref={(ref) => this.packagePrice = ref}
                style={{ height: '44px', borderRadius: '8px' }}
              />
            </div>
          </div>

          <div style={styles.menuSectionTitle}>{staticContent.PACKAGE_PAGE_PACKAGE_MENU_TITLE ? staticContent.PACKAGE_PAGE_PACKAGE_MENU_TITLE : 'Menu'}</div>
          <div style={styles.menuGrid}>
            {
              this?.state?.menu && this?.state?.menu?.length > 0 && this?.state?.menu.map(item => (
                <div key={item._id} style={styles.menuItem}>
                  <span style={styles.menuItemLeft} onClick={() => this.handleSelectMenuItem(item._id, item.isSelected)}>
                    <Checkbox checked={item.isSelected && item.isSelected}/>
                    <span style={{ marginLeft: '8px', cursor: 'pointer' }}>{item.name}</span>
                  </span>
                  {
                    item?.isSelected && item?.selectedCount > 0 ?
                      <span style={styles.counterBox}>
                        <span style={styles.counterBtn} onClick={() => this.handleDecrementMenuItem(item._id)}>-</span>
                        <span style={styles.counterVal}>{item.selectedCount && item.selectedCount}</span>
                        <span style={styles.counterBtn} onClick={() => this.handleIncrementMenuItem(item._id)}>+</span>
                      </span> : null
                  }
                  {
                    item.selectedCount === 0 ?
                      <span onClick={() => this.handleIncrementMenuItem(item._id)} style={styles.addItemBtn}>
                        <span style={{ padding: '0px 7px', marginRight: '3px' }}>Add</span>
                        <span style={{ padding: '0px 7px', color: '#2563eb' }}>+</span>
                      </span> : null
                  }
                </div>
              ))
            }
          </div>
        </div>

        <div className="custom-drawer-footer">
          <button
            className="btn-secondary-custom"
            onClick={this.props.handleCloseEditPackageOverlay}
            type="button"
          >
            Cancel
          </button>
          <Button
            disabled={this?.props?.isUpdatingSubPackage && this.props.isUpdatingSubPackage}
            className="btn-primary-custom"
            onClick={() => this.savePackage()}
            type="button"
          >
            {this.props.isUpdatingSubPackage ? <SpinnerLoader /> : (staticContent.PACKAGE_PAGE_PACKAGE_SAVE_BUTTON_TEXT ? staticContent.PACKAGE_PAGE_PACKAGE_SAVE_BUTTON_TEXT : 'SAVE')}
          </Button>
        </div>
      </div>
    );
  }
}

export default EditPackage;
